export * from './aps-patner-promotion-item';
